<div class="row">
  <div class="container-carousel">
      <div id="id-carousel" class="carousel" class="carousel slide" data-interval="false" data-wrap="false">
          <ol class="carousel-indicators">
              <li (click)="posicion0()" data-target="#id-carousel" data-slide-to="0" class="active"></li>
              <li (click)="posicion1()" data-target="#id-carousel" data-slide-to="1"></li>
          </ol>
          <div class="carousel-inner">
              <div class="carousel-item active">
                  <img class="imagen-cedula imagen-cedula-anverso" src="assets/images/group-5.png">
                  <p class="descripcion-cedula">Para cédulas posteriores a 2013, el número de serie se encuentra en el anverso</p>
                  <div class="carousel-caption d-none d-md-block">
                  </div>
              </div>
              <div class="carousel-item">
                  <img class="imagen-cedula imagen-cedula-reverso" src="assets/images/group-5-reversa.png">
                  <p class="descripcion-cedula">Para cédulas anteriores a 2013, el número de serie se encuentra al reverso</p>
                  <div class="carousel-caption d-none d-md-block">
                  </div>
              </div>
          </div>
          <a (click)="posicion0()" class="carousel-control-prev" [ngClass]="{'posicion0':validador, 'posicion1':!validador}" href="#id-carousel" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
          </a>
          <a (click)="posicion1()" class="carousel-control-next" [ngClass]="{'posicion0':!validador, 'posicion1':validador}" href="#id-carousel" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
          </a>
      </div>
  </div>
</div>
